import mock from '@/fake-db/mock.js'
import jwt from 'jsonwebtoken'

const data = {
  checkpointReward: {
    projectName: 'John',
    progress: '57.6%'
  },
  projects: [
    {
      uid: 34,
      displayName: 'Howard Potts',
      password: 'adminadmin',
      photoURL: require('@/assets/images/portrait/small/avatar-s-5.jpg'),
      email: 'admin@admin.com',
      phoneNumber: null
    }
  ]
}


const jwtConfig = {
  'secret'   : 'dd5f3089-40c3-403d-af14-d0c228b05cb4',
  'expireTime': 8000
}


mock.onPost('/api/auth/login').reply((request) => {
  const {email, password} = JSON.parse(request.data)

  let error = 'Something went wrong'

  const project = data.projects.find(project => project.email === email && project.password === password)

  if (project) {

    try {

      const accessToken = jwt.sign({id: project.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

      const projectData = Object.assign({}, project, {providerId: 'jwt'})

      delete projectData.password

      const response = {
        projectData,
        accessToken
      }

      return [200, response]

    } catch (e) {
      error = e
    }
  } else {
    error = 'Email Or Password Invalid'
  }

  return [200, {error}]


})

mock.onPost('/api/auth/register').reply((request) => {
  const {displayName, email, password} = JSON.parse(request.data)
  const isEmailAlreadyInUse = data.projects.find((project) => project.email === email)
  const error = {
    email      : isEmailAlreadyInUse ? 'This email is already in use.' : null,
    displayName: displayName === '' ? 'Please enter your name.' : null
  }

  if (!error.displayName && !error.email) {

    const projectData = {
      email,
      password,
      displayName,
      photoURL: require('@/assets/images/portrait/small/avatar-s-5.jpg'),
      phoneNumber: null
    }

    // Add project id
    const length = data.projects.length
    let lastIndex = 0
    if (length) {
      lastIndex = data.projects[length - 1].uid
    }
    projectData.uid = lastIndex + 1

    data.projects.push(projectData)

    const accessToken = jwt.sign({id: projectData.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expireTime})

    const project = Object.assign({}, projectData)
    delete project['password']
    const response = {
      projectData: project,
      accessToken
    }

    return [200, response]
  } else {
    return [200, {error}]
  }
})


mock.onPost('/api/auth/refresh-token').reply((request) => {

  const {accessToken} = JSON.parse(request.data)

  try {
    const {id} = jwt.verify(accessToken, jwtConfig.secret)

    const projectData = Object.assign({}, data.projects.find(project => project.uid === id))

    const newAccessToken = jwt.sign({id: projectData.uid}, jwtConfig.secret, {expiresIn: jwtConfig.expiresIn})

    delete projectData['password']
    const response = {
      projectData,
      accessToken: newAccessToken
    }

    return [200, response]
  } catch (e) {
    const error = 'Invalid access token'
    return [401, {error}]
  }
})


mock.onGet('/api/project/checkpoint-reward').reply(() => {
  return [200, data.checkpointReward]
})
